import { Box, Text } from '@chakra-ui/react'
import React, { useMemo } from 'react'

import { borderVariant25, defaultBorder3 } from '@/chakraTheme.js'


const OptionsSelector = ({
    mode,
    emojiData,
    selectedEmoji,
    selectedCategories,
    options,
    selectedOptions,
    setSelectedOptions,
}) => {
    const optionsToDisplay = useMemo(() => {
        if (mode === 'OPTIONS') return options

        // For category mode
        return selectedCategories.flatMap(categoryKey => {
            const category = emojiData
                .find(e => e.name === selectedEmoji)
                .categories.find(cat => Object.keys(cat)[0] === categoryKey)
            return category[categoryKey].options
        })
    }, [mode, options, selectedEmoji, selectedCategories])

    return (
        <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            alignItems="center"
            gap={3}
        >
            {optionsToDisplay.map(option => {
                const [optionKey, optionValue] = Object.entries(option)[0]
                const isSelected = selectedOptions.includes(optionKey)

                return (
                    <Box
                        key={optionKey}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        paddingX={4}
                        paddingY={3}
                        lineHeight={4}
                        cursor="pointer"
                        backgroundColor={
                            isSelected ? 'mischka2' : 'athensgray4'
                        }
                        border={isSelected ? borderVariant25 : defaultBorder3}
                        onClick={() =>
                            setSelectedOptions(prev =>
                                isSelected
                                    ? prev.filter(item => item !== optionKey)
                                    : [...prev, optionKey]
                            )
                        }
                        transition="all 0.2s ease-in-out"
                        _hover={{
                            transform: 'scale(1.05)',
                        }}
                    >
                        <Text fontSize="sm" fontFamily="Roboto">
                            {optionValue}
                        </Text>
                    </Box>
                )
            })}
        </Box>
    )
}

export default OptionsSelector
